import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import '../styles/mudatagridcustomstyle.css';
import axios from 'axios';
import MaterialNotifyComponent from './MaterialNotifyComponent';
import { getAuthenticationToken } from '../utils/TokenHandler';
import { Alert, Backdrop, CircularProgress } from '@mui/material';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    defaults,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import styled from 'styled-components';

const columns = [
    {
        field: 'id',
        headerName: '#',
        editable: false,
    },
    {
        field: 'pointType',
        headerName: 'نوع',
        editable: false,
    },
    {
        field: 'totalPoint',
        headerName: 'امتیاز',
        editable: false,
    },
    {
        field: 'pointPersianDateTime',
        headerName: 'تاریخ',
        editable: false,
    },
];

function ScoreList(props) {
    const [customerPointHistories, setCustomerPointHistories] = useState([]);
    const [messageNotify, setMessageNotify] = useState({ severity: "error", message: "", open: false });
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const url = (props.isMerchant ? 'api/v2/Dashboard/GetMerchantPointHistories' : 'api/v2/Dashboard/GetCustomerPointHistories');
        const urlParams = (props.isMerchant ? {
            params:
            {
                merchantId: getAuthenticationToken().merchantId
            }
        } : {
            params:
            {
                userId: getAuthenticationToken().userID
            }
        });
        setOpen(true);
        axios.get(url, urlParams).then((response) => {
            setCustomerPointHistories(response.data);
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }, []);

    defaults.font.family = 'IRAN Sans';
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            title: {
                display: true,
                text: props.mainTitle,
            },
        },
        maintainAspectRatio: false
    };

    const labels = customerPointHistories.map((item) => item.pointPersianDateTime)
    const data = {
        labels,
        datasets: [
            {
                label: props.mainTitle,
                data: customerPointHistories.map((item) => item.totalPoint),
                borderColor: '#5726db',
                backgroundColor: 'rgba(87, 38, 219, 0.5)',
            }
        ],
    };

    const ChartContainer = styled.div`
    background-color:#fff;
    border-radius:1.2rem;
    width:96%;
    height:15.5rem;
    padding:1.8rem;
    text-align:center;
    margin:10px 0;
    @media screen and (min-width: 320px) and (max-width: 1080px){
        height:max-content;
        width: 80% !important;
        margin:auto;
        margin-right:0;
        margin-top:10px;
    }
`;

    return (customerPointHistories !== null) && (
        <>
            <DataGrid className={'rtl-grid'}
                rows={customerPointHistories}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                direction="row-reverse"
                disableSelectionOnClick
                disableColumnMenu
                exportDataAsCsv={(e) => console.log('exportDataAsCsv', e)}
            />
            <ChartContainer>
                <Line options={options} data={data} />
            </ChartContainer>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default ScoreList;